// extracted by mini-css-extract-plugin
export default {"qa":"QA_qa__GELTd","header":"QA_header__eYXKP","faqWrapper":"QA_faqWrapper__OJl+g"};